import axios from 'axios'
import { UrlBase } from './config'

const images = {}

images.uploadImageApp = (token, data) => {
  return new Promise((resolve, reject) => {
    /* eslint-disable */
    let fd = new FormData()
    /* eslint-enable */
    fd.append('type', 'apps')

    if (data.picture) {
      fd.append('image-file', data.picture)
    }

    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'image',
      data: fd
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

images.uploadImageEvent = (token, data) => {
  return new Promise((resolve, reject) => {
    /* eslint-disable */
    let fd = new FormData()
    /* eslint-enable */
    fd.append('type', 'events')

    if (data.picture) {
      fd.append('image-file', data.picture)
    }

    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'image',
      data: fd
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

export default images
